/** Hero display names.
 *
 * `ObservedHero` carries the def id, not a name; the name is in the content
 * bundle. Its own file because both a panel and a pure describer need it, and
 * the describers must stay importable without React.
 */

import type { ContentRegistry, HeroDefId, ObservedHero } from "@game/core";

/**
 * Falls back to a title-cased form of the id when the bundle has not loaded.
 * Hero ids are `<faction>_<name>` (199 of them, no exceptions), so dropping the
 * first segment gives a usable name rather than "Castle Perton".
 */
export function heroDisplayName(hero: ObservedHero, content: ContentRegistry | null): string {
  const def = content?.heroes.get(hero.def as HeroDefId);
  if (def !== undefined) return def.name;
  const tail = hero.def.split("_").slice(1).join(" ");
  const text = tail === "" ? hero.def : tail;
  return text.replace(/\b[a-z]/g, (c) => c.toUpperCase());
}
